<template>
  <div id="waitTrust">
    <v-card
      class="mx-auto"
      max-width="600"
      min-width="300"
      min-height="80"
      color="#f6f6fa"
    >
    <p style="color:#FFFFFF;background-color:#5555BB"><b>信用の確立</b></p>
    <div class="wait-trust-area">
      <div v-if="isLeader">
        <div v-if="!sent">
          <p>一人選択し，<br><span v-on:click="showEffect" class="plot-name"><b><u>信用の確立</u></b></span>を使用して下さい．</p>
          <div class="assigning-table">
            <v-row class="mx-auto">
              <v-col class="my-n2" v-for="(user, key) in users.filter(user => user.id != userId)" v-bind:key="user.name" >
                <v-card class="" elevation=0 max-width=240 min-width=240>
                  <div style="text-align:left;">
                    <v-simple-table dense >
                      <td class="assigning-td" style="width:90px;">
                        <div class="assign-button background-color">
                          <pickButton v-if="isAssigned[key]" v-on:pushed="assign(key)" activeLabel="選択" inactiveLabel="未選択" active="true" />
                          <pickButton v-else v-on:pushed="assign(key)" activeLabel="選択" inactiveLabel="未選択" active="false" />
                        </div>
                      </td>
                      <td class="assigning-td" style="padding-left:12px;width:140px">
                        <span class="user-label">{{ user.name }}</span>
                      </td>
                    </v-simple-table>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>

          <div class="send-button">
            <sendButton v-if="isAssigned.indexOf(true)>=0" v-on:pushed="push" label="決定" active="true"/>
            <sendButton v-else label="決定" active="false"/>
          </div>
        </div>
        <div v-else>
          <span>ゲーム情報を取得しています．</span>
        </div>
      </div>
      <div v-else>
        <p>リーダーが<span v-on:click="showEffect(8)" class="plot-name"><b><u>信用の確立</u></b></span>を使用しています．</p>
      </div>
    </div>
  </v-card>
  </div>
</template>

<script>
import pickButton from '@/components/gameUiComponents/PickedButton.vue'
import sendButton from '@/components/gameUiComponents/SendButton.vue'
export default {
  name: "waitTrust",
  plops: [],
  components: {
    pickButton,
    sendButton
  },
  data() {
    return {
      roomId: this.$store.state.gameInfo.roomId,
      userId: this.$store.state.userInfo.id,
      leader: this.$store.getters.leader,
      socket: this.$store.state.webSocket.socket,
      plotEffect: "",
      target: null,
      isAssigned: [],
      sent: false
    }
  },
  computed: {
    users: function() {
      return this.$store.state.userList.users;
    },
    round () {
      return this.$store.state.missionInfo.round
    },
    isLeader: function() {
      // return true
      return this.$store.getters.isLeader;
    },
    isAssign : function(num) {
      return this.isAssigned[num]
    },
    drawnPlots : function() {
      return this.$store.getters.getDrawnPlots(this.round)
    },
  },
  methods: {
    waitTrust: function() {
      if (!this.target) {
        return;
      }
      // TODO このメソッドが二回実行されないような仕組み、ボタン非活性など
      var event = {};
      event.name = "waitTrust";
      event.target = this.target;
      this.$emit("next", event);
    },
    assign(num) {
      if (this.isAssigned[num]){
        this.$set(this.isAssigned, num, false)
      }else {
        for (var i=0; i<this.users.length; i++){
          this.$set(this.isAssigned, i, false)
        }

        this.$set(this.isAssigned, num, true)
        // this.isAssigned[num] = true
        // this.previousSelect = num

      }
    },
    showEffect: function(){
      var plot = this.$store.getters.getPlotEffect(8);
      var modalContent = {title: plot.name, text: plot.effect}
      this.$emit('send-modal', modalContent)
    },
    push: function() {
      // this.sent = true
      this.$emit("send-request", {"action": "execute-trust", "roomId": this.roomId, "userId": this.userId, data: {"trust": this.users.filter(user => user.id != this.userId)[this.isAssigned.indexOf(true)].id}})
    }
  },
  created() {
    for (var i in this.isAssigned){
      this.$set(this.isAssigned, i, false)
      // this.isAssigned[i] = false
    }
    var self = this
    this.socket.onmessage = function(event){
      console.log("Received")
      console.log(event)
      const res = JSON.parse(event.data)
      if (!res.state) {return}
      // self.$emit("show-text", {state: "assigning-mission", text: snackText})
      var snackText = "信用の確立により，リーダー("
      snackText += self.$store.getters.getUserById(res.data.trust.userId).name
      snackText += ")の役割が"

      if (res.data.trust.role == 'resistance'){
        snackText += "[レジスタンス]であることが判明しました．"
      }else if (res.data.trust.role == 'spy'){
        snackText += "[スパイ]であることが判明しました．"
      }else {
        snackText += "[?]であることが判明しました．"
      }
      self.$emit("show-text", {state: "wait-trust", text: snackText})

      self.$store.commit('deletePlot', {'userId': self.leader.id, 'plotId': 8})
      var nextState = "assigning-plots"
      if (res.state == "assigning-plots"){
        nextState = "assigningPlots"
      }else if(res.state == "assigning-mission"){
        nextState = "assigningMission"
      }
      self.$emit("proceed-state", nextState)
    }
  }
};
</script>

<style>
#waitTrust {
}
#waitTrust .send-button{
  padding-bottom: 12px
  /* display: inline-block; */
}
#waitTrust .assigning-table {
 align-items: left;
 display: inline-block;
 text-align:center;
}
#waitTrust td {
  font-size: 16px;
  border-bottom-width: 0px;
  background-color: #F6F6FA;
}
#waitTrust .background-color {
  background-color: #F6F6FA;
}
#waitTrust .assign-button {
  margin-top: 4px;
  margin-bottom: 4px;
  background-color: #FFFFFF
}
#waitTrust .invalid-button {
  margin-top: 4px;
  margin-bottom: 4px;
  background-color: #F6F6FA
}
#waitTrust .plot-name {
  color: #5555BB;
  cursor:pointer;
}
</style>
